import type { AlgoliaCity } from '~/composables/types/algolia'
import { useAlgoliaIndexNames } from '~/composables/algolia/useAlgoliaIndexNames'

export const useAlgoliaLocalities = async (
  initialCitySlug = '',
  immediate = true
) => {
  const searchQuery = ref('')
  const citySlug = ref(initialCitySlug)
  const defaultReqOpts = {
    similarQuery: '',
    clickAnalytics: true,
    hitsPerPage: 20,
  }
  const { locations: locationsIndex } = useAlgoliaIndexNames()

  const { result: localitiesAlgolia, search } =
    useAlgoliaSearch<AlgoliaCity>(locationsIndex)

  const { execute } = await useAsyncData(
    locationsIndex,
    () => {
      return search({
        query: searchQuery.value,
        requestOptions: {
          ...defaultReqOpts,
          optionalFilters: [`slug:${citySlug.value}`],
          aroundLatLngViaIP:
            !citySlug.value && import.meta.client && !searchQuery.value,
        },
      })
    },
    {
      immediate,
      deep: true,
      watch: [citySlug],
    }
  )

  async function searchLocalities(query: string) {
    searchQuery.value = query
    return await execute()
  }

  async function searchLocalitiesWithOptionalCityFilter(slug: string) {
    citySlug.value = slug
    return await execute()
  }

  return {
    localitiesAlgolia,
    setCitySlug: (citySlugVal: string) => {
      citySlug.value = citySlugVal
    },
    searchLocalities,
    searchLocalitiesWithOptionalCityFilter,
  }
}
